import React, { memo } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, bool } from 'prop-types'

function ClosedButtonSettings({ label, isActive, buttonLabel, disabled = false }) {
  return (
    <div className="collapsed-model-settings__row">
      <span className="collapsed-model-settings__title">{label}</span>
      <Button
        type="secondary"
        size="tiny"
        isActive={isActive}
        customClass="collapsed-model-settings__button"
        disabled={disabled}
      >
        {buttonLabel}
      </Button>
    </div>
  )
}

ClosedButtonSettings.propTypes = {
  label: string.isRequired,
  isActive: bool.isRequired,
  buttonLabel: string.isRequired,
  disabled: bool,
}

export default memo(ClosedButtonSettings)
